import { $, must } from './modules/dom.ts';
import { getText, reportErrors } from './modules/fetch-helpers.ts';

const copyImage = $('#copy-image') as HTMLElement | null;
if (copyImage) {
  copyImage.onclick = () => {
    const frameWindow = must(
      ($('iframe.canvas') as HTMLIFrameElement).contentWindow,
      'canvas iframe window',
    );
    const canvas = frameWindow.document.querySelector('#screen') as HTMLCanvasElement;
    navigator.clipboard.writeText(`![Graphic](${canvas.toDataURL()})`);
  };
}

($('#open-resizable') as HTMLElement).onclick = reportErrors(
  'open the resizable canvas',
  async () => {
    // Get the canvas and script from the iframe in the current page so we can
    // copy the size from the canvas and the code from the script.
    const origIframe = $('iframe.canvas') as HTMLIFrameElement;
    const origDoc = must(origIframe.contentWindow, 'canvas iframe window').document;
    const canvas = origDoc.querySelector('#screen') as HTMLCanvasElement;
    const script = must(origDoc.querySelector('script.injected'), 'injected script in iframe');
    const scriptCode = (script.textContent ?? '').replace(/^\s*minibuffer.*$/gm, '');

    const origFramework = origDoc.querySelector('script[src]') as HTMLScriptElement;
    const frameworkURL = new URL(origFramework.src, origIframe.src);

    const fw = await getText(frameworkURL.href);

    const w = must(
      open(
        '/frames/resizable/',
        '_blank',
        `popup=true,width=${canvas.width},height=${canvas.height}`,
      ),
      'resizable popup window',
    );

    w.onload = () => {
      const canvas = must(w.document.querySelector('canvas'), 'canvas in popup');
      const ctx = must(canvas.getContext('2d'), '2d context');
      const code = `${fw}\n\n${scriptCode}`;

      const redraw = () => {
        const iframe = w.document.createElement('iframe');
        must(w.document.body.querySelector('iframe'), 'iframe in popup').replaceWith(iframe);
        // Expose the popup's canvas as a global inside the iframe, where the
        // framework code runs.
        (
          must(iframe.contentWindow, 'new iframe window') as Window & {
            canvas?: HTMLCanvasElement;
          }
        ).canvas = canvas;

        ctx.reset();

        const frameDoc = must(iframe.contentDocument, 'new iframe document');
        const script = frameDoc.createElement('script');
        script.textContent = code;
        frameDoc.head.append(script);
      };

      w.onresize = redraw;

      // Forward key events from the pop-out window into the iframe
      // where the framework's keyboard handlers are listening.
      const forwardKey = (type: string) => (e: KeyboardEvent) => {
        const iframe = w.document.querySelector('iframe');
        iframe?.contentDocument?.dispatchEvent(new KeyboardEvent(type, { key: e.key }));
      };
      w.document.onkeydown = forwardKey('keydown');
      w.document.onkeyup = forwardKey('keyup');

      redraw();
    };
  },
);
